import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import { Cookie, X } from "lucide-react";

export default function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("wta_cookie_consent")) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem("wta_cookie_consent", "accepted");
    setShow(false);
  };
  const decline = () => {
    localStorage.setItem("wta_cookie_consent", "declined");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:bottom-6 sm:start-6 sm:max-w-md z-50"
      data-testid="cookie-banner"
    >
      <div className="surface-card p-4 sm:p-5 bg-white shadow-2xl">
        <div className="flex items-start gap-3">
          <span className="w-9 h-9 rounded-xl bg-zinc-900 grid place-items-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-white" strokeWidth={1.8} />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium leading-snug">
              {t("cookie_banner_text")}{" "}
              <Link to="/legal/cookies" className="underline underline-offset-4">
                {t("cookie_banner_link")}
              </Link>
            </p>
          </div>
          <button onClick={decline} className="text-zinc-400 hover:text-zinc-700" aria-label="Dismiss">
            <X className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={decline} data-testid="cookie-decline" className="btn btn-secondary btn-sm flex-1">
            {t("cookie_decline")}
          </button>
          <button onClick={accept} data-testid="cookie-accept" className="btn btn-primary btn-sm flex-1">
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
